import {
	getDaysBetweenDates,
	getYearsOld,
	morphForWords,
} from 'components/shared/processes'
import { ICowsList } from 'models/ICattlesData'
import moment from 'moment'

export const EMPTY_MAIN_INFO_CELL = '-'
export const NO_LAMENESS_DATA = 'Нет данных'

export const hasValue = (value: unknown) => {
	if (value === null || value === undefined) return false
	if (typeof value === 'string') return value.trim().length > 0
	if (typeof value === 'number') return !Number.isNaN(value)
	return true
}

export type DateDaysValue = {
	primary: string
	days: number | string
	dayWord: string
}

export const formatDateWithDays = (
	timestamp?: number | null,
	now = Date.now(),
): DateDaysValue => {
	if (!hasValue(timestamp)) {
		return {
			primary: EMPTY_MAIN_INFO_CELL,
			days: EMPTY_MAIN_INFO_CELL,
			dayWord: 'день',
		}
	}

	const days = getDaysBetweenDates({
		startDate: timestamp,
		endDate: now,
	})

	return {
		primary: moment(timestamp).format('DD.MM.YY'),
		days,
		dayWord: morphForWords(days, ['день', 'дня', 'дней']),
	}
}

export const formatLactationLabel = (
	length?: number | string | null,
	count?: number | string | null,
) => {
	if (!hasValue(length)) return ''
	const days = `${length} ${morphForWords(Number(length), [
		'день',
		'дня',
		'дней',
	])}`
	return hasValue(count) ? `${days} (№${count})` : days
}

export const formatLamenessValue = (
	score?: number | null,
	startDt?: number | null,
	now = Date.now(),
): DateDaysValue | null => {
	if (!hasValue(score)) return null
	if (!hasValue(startDt)) {
		return {
			primary: String(score),
			days: EMPTY_MAIN_INFO_CELL,
			dayWord: 'день',
		}
	}

	const days = getDaysBetweenDates({
		startDate: startDt,
		endDate: now,
	})
	return {
		primary: String(score),
		days,
		dayWord: morphForWords(days, ['день', 'дня', 'дней']),
	}
}

export type MainInfoTextField = {
	label: string
	value: string
}

export const getMainInfoLeftFields = (
	cowInfo?: ICowsList | null,
): MainInfoTextField[] => {
	if (!cowInfo) return []

	const age = cowInfo.birth_date ? getYearsOld(cowInfo.birth_date) : ''
	const lactationLabel = formatLactationLabel(
		cowInfo.lactation_length,
		cowInfo.lactation_count,
	)

	return [
		{
			label: 'Номер ушной бирки:',
			value: hasValue(cowInfo.tag_id)
				? String(cowInfo.tag_id)
				: EMPTY_MAIN_INFO_CELL,
		},
		hasValue(cowInfo.collar_num) && {
			label: 'Номер ошейника:',
			value: String(cowInfo.collar_num).trim(),
		},
		{
			label: 'Группа:',
			value: hasValue(cowInfo.group?.title)
				? cowInfo.group.title
				: EMPTY_MAIN_INFO_CELL,
		},
		hasValue(age) && { label: 'Возраст:', value: age },
		hasValue(lactationLabel) && {
			label: 'День лактации:',
			value: lactationLabel,
		},
	].filter(Boolean) as MainInfoTextField[]
}
